import Card from "@ergeon/core-components/exports/Card.ts";

export default function ConsentNotice() {
  return (
    <Card className="max-w-lg flex-col p-4 md:p-5" flavor="regular" rounded="medium">
      <h3 className="heading-6 text-gray-900 dark:text-gray-100">
        Recording Notice &amp; Consent
      </h3>
      <p className="paragraph-2 mt-2 text-gray-700 dark:text-gray-300">
        We record and transcribe our calls for quality assurance, training, and
        project preparation.
      </p>
      {/* Bullets hang outside the text column so a wrapped line lines up with
          the line above it instead of sliding back under the marker. */}
      <ul className="paragraph-2 mt-3 list-outside list-disc space-y-2 pl-5 text-gray-700 marker:text-gray-400 dark:text-gray-300 dark:marker:text-gray-500">
        <li>
          By clicking the blue &ldquo;Join &amp; Consent&rdquo; button, you
          agree to this recording.
        </li>
        <li>
          Your phone&rsquo;s location during the walkthrough is also recorded
          to map the walk to the video.
        </li>
        <li>If you do not consent, please do not join the call.</li>
      </ul>
    </Card>
  );
}
